import router from '../../../router'
import { Message, MessageBox, Notification } from 'element-ui';

export const clearAuthData = state => {
    router.push('/login')
    state.accessToken = null
    localStorage.removeItem('accessToken')        
    window.location.reload()
}

export const setAccessToken = (state, payload) => {

    state.accessToken = payload
    localStorage.setItem('accessToken', payload.access_token)
    state.login.user_id = ''
    state.login.password = ''    

    if(payload.navigate) {
        router.push('/')
    }

}

export const setMasterPageLimit = (state, payload) => {
    state.default_page_limit = payload.limit
}

export const setCountryList = (state, payload) => {
    state.country_list = payload    
}

export const setEStoreMenuList = (state, payload) => {
    state.e_store_menu_list = payload    
}

export const setProvinceList = (state, payload) => {
    state.province_list = payload    
}

export const setCityList = (state, payload) => {
    state.city_list = payload
}

export const resetProvinceList = state => {
    state.province_list = []    
}

export const resetCityList = state => {
    state.city_list = []
}

export const setSalutationList = (state, payload) => {
    state.salutation_list = payload
}

export const setMachineId = (state, payload) => {
    state.machineId = payload
}

export const toggleLoadingState = (state, payload) => {
    state.loadingState = payload
    //
    if(payload) {
        Message.warning({
            message: 'Please wait while processing...',
            duration: 0
        });        
    } else {
        Message.closeAll()             
    }
    
}

export const displayErrorNotification = (state, payload) => {
    
    state.loading = false

    Notification.error({
        title: "Error",
        message: payload.message,
        duration: 2000
    });
    
}

export const displaySuccessNotification = (state, payload) => {
    
    state.loading = false

    Notification.success({
        title: "Success",
        message: payload.message,
        duration: 2000
    });
    
}

export const displayMessageAlert = (state, payload) => {
    
    state.loading = false

    MessageBox.alert(payload.message, payload.type, {
        dangerouslyUseHTMLString: payload.displayHTML ? true : false
    })
    
}

export const appendBreadcrumbs = (state, payload) => {
    state.breadcrumbs = [{icon: 'el-icon-s-home', target: '/'}]
    payload.forEach(element => {
        state.breadcrumbs.push(element)
    })    
}

export const setCommunicationList = (state, payload) => {   
    
    state.communication_variables = payload

}

export const setMasterModuleList = (state, payload) => { 
    state.master_module_list = payload
}

export const setFabricWidthList = (state, payload) => {
    state.fabric_width_list = payload
}

export const setCurrencyProps = (state, payload) => {
    if(payload.type === 1) {
        state.currency_format_1 = payload.format
    } else if(payload.type === 2) {
        state.currency_format_2 = payload.format
    }
}

export const setUOMList = (state, payload) => {
    state.uom_list = payload
}

export const setFabricGSMList = (state, payload) => {
    state.fabric_gsm_list = payload
}

export const setDashboard = (state, payload) => {
    state.dashboard.response = payload
}

export const setMasterQueryList = (state, payload) => {
    state.search_query_list = payload
}

export const setTaskCalendar = (state, payload) => {
    state.task_calendar_events = payload
}

export const setTaskCalendarEventList = (state, payload) => {
    state.task_calendar_event_list = payload
}

export const setWhatsappLicenseList = (state, payload) => {
    state.whatsapp_license_list = payload
}

export const setPaymentList = (state, payload) => {
    state.payment_list = payload
}

export const setCouponList = (state, payload) => {
    state.coupon_list = payload
}

export const setSubscriptionList = (state, payload) => {
    state.subscription_list = payload
}


// WEBPACK FOOTER //
// ./src/store/modules/master/mutations.js